// @flow

import * as React from 'react';

import { buildStaticAssetUrl } from '@zapier/common-utils';

type Props = {
  children: React.Node,
  staticAssetPath: string,
};

const defaultContext = {
  staticAssetPath: '',
};

const StaticAssetContext = React.createContext(defaultContext);

export const useStaticAssetPath = () => {
  const { staticAssetPath } = React.useContext(StaticAssetContext);
  return {
    buildStaticAssetUrl: (url: string) =>
      buildStaticAssetUrl(url, staticAssetPath),
    staticAssetPath,
  };
};

/**
 * React context that provides the `staticAssetPath` function to `StaticImage`
 * components to be able to do client side routing when needed
 */
const StaticAssetProvider = ({ children, staticAssetPath }: Props) => {
  return children ? (
    <StaticAssetContext.Provider value={{ staticAssetPath }}>
      {React.Children.only(children)}
    </StaticAssetContext.Provider>
  ) : null;
};

export default StaticAssetProvider;
